// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"372":"821cb3ea","943":"f5a60a3d"}[chunkId] + ".chunk.js";
};